import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { InsideMaterialCarousel } from '../components/InsideMaterialCarousel';
import { ModulesSection } from '../components/ModulesSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-283" data-mp="llw8889nnsm6">
      <HeroSection data-id="element-284" data-mp="lnpbddl27upf" />
      <ProofSection data-id="element-285" data-mp="2zj6yz5fkhp5q" />
      <ProblemSection data-id="element-286" data-mp="2zjq7jvjbv173" />
      <SystemSection data-id="element-287" data-mp="2zk8dxkzpevsq" />
      <InsideMaterialCarousel data-id="element-288" data-mp="2zgu8u4zno8hl" />
      <ModulesSection data-id="element-289" data-mp="33k8ylndec388" />
      <BonusSection data-id="element-290" data-mp="33lk3xrmhpj1g" />
      <UrgencySection data-id="element-291" data-mp="33l1xk2645oft" />
      <PricingSection data-id="element-292" data-mp="33ifotz7hl2w0" />
      <TestimonialsSection data-id="element-293" data-mp="38jvclz11tni3" />
      <GuaranteeSection data-id="element-294" data-mp="38ik980bimhri" />
      <FAQSection data-id="element-295" data-mp="38iaiubmk68la" />
      <FinalCTA data-id="element-296" data-mp="38hsesstnmq2t" />
      <Footer data-id="element-297" data-mp="3da201vjtr1yr" />
    </main>;
}